import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-powered-by-stellar',
  templateUrl: './powered-by-stellar.component.html',
  styleUrls: ['./powered-by-stellar.component.scss'],
})
export class PoweredByStellarComponent {
  constructor() {}
}
